import { BoxProps, TextProps } from '@chakra-ui/react'
import ProductsCarousel from '@components/product/products-carousel'
import { useStore } from '@contexts/store'
import { useGetRelatedShopProducts } from '@framework/products/get-shop-products'
import { RefObject, useMemo } from 'react'

interface RelatedProductsProps {
  carouselBreakpoint?: {} | any
  className?: string
  uniqueKey?: string
  product: any
  pageTopRef?: RefObject<HTMLDivElement>
  boxStyleProps?: BoxProps
  headingStyleProps?: TextProps
}

const RelatedProductFeed: React.FC<RelatedProductsProps> = ({
  carouselBreakpoint,
  className,
  uniqueKey = 'related-product-popup',
  product,
  pageTopRef,
  boxStyleProps,
  headingStyleProps,
}) => {
  const { storeData: shopData, storeTemplate } = useStore()
  const { relatedProducts, isLoading, isError, filter } =
    useGetRelatedShopProducts(shopData?._id, product)

  // remove product from related products
  const relatedProductsData = useMemo(() => {
    if (!isLoading && relatedProducts?.data) {
      return relatedProducts?.data.filter(
        (item: any) => item._id !== product._id,
      )
    }
    return []
  }, [relatedProducts, product, isLoading])

  if (relatedProductsData.length === 0) return null

  return (
    <ProductsCarousel
      sectionHeading={'Related Products'}
      categorySlug={filter}
      className={className}
      products={relatedProductsData}
      loading={isLoading}
      error={"Can't load related products"}
      limit={10}
      uniqueKey={uniqueKey}
      carouselBreakpoint={carouselBreakpoint}
      pageTopRef={pageTopRef}
      boxStyleProps={
        storeTemplate === 'ELEGANT' ? { bg: '#F7FAFF', py: '7' } : undefined
      }
      headingStyleProps={
        storeTemplate === 'ELEGANT'
          ? {
              color: 'elegantBlack',
              w: 'full',
              textAlign: 'center',
              fontWeight: '700',
              fontSize: { base: '20px', lg: '28px' },
              my: { base: '5', lg: '7' },
            }
          : undefined
      }
    />
  )
}

export default RelatedProductFeed
